import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { BACKEND_API } from "../../constants/backendApi";

//Style
import "./FormWithStepsComponent.css";

//Context
import { PopupContext } from "../../context/PopupContext";
import { LoadingContext } from "../../context/LoadingContext";

const FormWithStepsComponent = ({
  createCreditUserData,
  inputData,
  getRefreshDataState,
  refreshData,
  hasSteps,
  hasRestoreBtn,
  userData,
}) => {
  const history = useNavigate();

  const { setLoading } = useContext(LoadingContext);

  const location = useLocation();

  const [stepNumber, setStepNumber] = useState(0);

  const [progress, setProgress] = useState(1);

  const progressFraction = 100 / inputData.steps.length;

  const [formData, setFormData] = useState({});

  const { setShowPopup, setPopupData } = useContext(PopupContext);

  const token = localStorage.getItem("token");

  const [modifiedField, setModifiedField] = useState([]);

  const userProfile = localStorage.getItem("userProfile") || "User";

  const [errorCodeList, setErrorCodeList] = useState([]);

  const errorListFromLS = JSON.parse(localStorage.getItem("error_list"));

  const renovationUserData = JSON.parse(localStorage.getItem("userData"));

  const creatorDocument = JSON.parse(localStorage.getItem("creator_document"));

  const isFromWhatsapp = JSON.parse(localStorage.getItem("is_from_whatsapp"));

  const [showTotalAnnualErr, setShowTotalAnnualErr] = useState(false);

  const [totalAnnualMsg, setTotalAnnualMsg] = useState("");

  useEffect(() => {
    if (location.pathname === "/admin/crear-credito/formulario-confirmar") {
      const capitalizeFirstLetters = (str) => {
        return str.replace(/\b\w/g, (match) => match.toUpperCase());
      };

      const dataFromLS = JSON.parse(localStorage.getItem("data"));

      setFormData({
        req_type: inputData.type,
        first_name:
          dataFromLS && dataFromLS.nombres
            ? dataFromLS.nombres
            : createCreditUserData && createCreditUserData.Nombres
            ? capitalizeFirstLetters(createCreditUserData.Nombres)
            : null,

        last_name:
          dataFromLS && dataFromLS.apellidos
            ? dataFromLS.apellidos
            : createCreditUserData && createCreditUserData.Apellidos
            ? capitalizeFirstLetters(createCreditUserData.Apellidos)
            : "N/A",
        doc_type:
          dataFromLS && dataFromLS.tipo_documento
            ? dataFromLS.tipo_documento
            : createCreditUserData && createCreditUserData.Tipo_Documento
            ? createCreditUserData.Tipo_Documento
            : null,
        num_document:
          dataFromLS && dataFromLS.numero_doc
            ? dataFromLS.numero_doc
            : createCreditUserData && createCreditUserData.NumeroDoc
            ? createCreditUserData.NumeroDoc
            : null,
        birth_department: createCreditUserData?.DepartamentoDeNacimiento
          ? createCreditUserData.DepartamentoDeNacimiento
          : null,
        birth_place:
          createCreditUserData && createCreditUserData.CiudadDeNacimiento
            ? createCreditUserData.CiudadDeNacimiento
            : null,
        birthdate:
          createCreditUserData && createCreditUserData.FechaNacimiento
            ? createCreditUserData.FechaNacimiento
            : null,
        issuance_department: createCreditUserData?.DepartamentoDeExpedicion
          ? createCreditUserData.DepartamentoDeExpedicion
          : null,
        issuance_place:
          createCreditUserData && createCreditUserData.CiudadDeExpedicion
            ? createCreditUserData.CiudadDeExpedicion
            : null,
        date_issuance:
          createCreditUserData && createCreditUserData.FechaExpedicion
            ? createCreditUserData.FechaExpedicion
            : null,
        genre: createCreditUserData.Sexo ?? null,
        email:
          dataFromLS && dataFromLS.correo_electronico
            ? dataFromLS.correo_electronico
            : null,
        phone:
          dataFromLS && dataFromLS.cel_titular_credito
            ? dataFromLS.cel_titular_credito
            : createCreditUserData && createCreditUserData.Cel_Titular_Credito
            ? createCreditUserData.Cel_Titular_Credito
            : null,
        agent: null,
        job:
          dataFromLS && dataFromLS.ocupacion_titular_credito
            ? dataFromLS.ocupacion_titular_credito
            : null,
        salary:
          dataFromLS && dataFromLS.ingresos_titular_del_credito
            ? dataFromLS.ingresos_titular_del_credito
            : null,
        country: "",
        department: "",
        city:
          dataFromLS && dataFromLS.ciudad_residencia
            ? dataFromLS.ciudad_residencia
            : null,
        address:
          dataFromLS && dataFromLS.direccion_residencia
            ? dataFromLS.direccion_residencia
            : null,
        num_policy:
          createCreditUserData && createCreditUserData.No_Poliza
            ? createCreditUserData.No_Poliza
            : "",
        insurer_place:
          createCreditUserData && createCreditUserData.Idsucursal
            ? createCreditUserData.Idsucursal
            : null,
        insurer:
          createCreditUserData && createCreditUserData.Aseguradora
            ? createCreditUserData.Aseguradora
            : "",
        name_broker: "",
        broker:
          dataFromLS && dataFromLS.asesor_intermediario
            ? dataFromLS.asesor_intermediario
            : "",
        plate:
          createCreditUserData && createCreditUserData.Placa
            ? createCreditUserData.Placa
            : "",
        init_term:
          createCreditUserData && createCreditUserData.Vig_inicial
            ? createCreditUserData.Vig_inicial
            : "",
        total_annual:
          createCreditUserData && createCreditUserData.Prima_Total
            ? createCreditUserData.Prima_Total
            : "",
        init_credit:
          createCreditUserData && createCreditUserData.Abono_Inicial
            ? createCreditUserData.Abono_Inicial
            : null,
        num_shares: "",
        credit_type: "",
        line:
          createCreditUserData && createCreditUserData.Linea
            ? createCreditUserData.Linea
            : null,
        brokerage_income:
          createCreditUserData && createCreditUserData.ing_Intermediario
            ? createCreditUserData.ing_Intermediario
            : null,
        is_new:
          createCreditUserData && createCreditUserData.is_new
            ? createCreditUserData.is_new
            : "false",
        observation_appendix:
          dataFromLS && dataFromLS.ObservacionesAnexo
            ? dataFromLS.ObservacionesAnexo
            : null,
        appendix: createCreditUserData?.Anexo ?? null,
        net_premium:
          createCreditUserData && createCreditUserData.PrimaNetaHDI
            ? createCreditUserData.PrimaNetaHDI
            : null,
        num_certificate:
          createCreditUserData && createCreditUserData.NoCertificado
            ? createCreditUserData.NoCertificado
            : null,
        num_risk:
          createCreditUserData && createCreditUserData.Riesgo
            ? createCreditUserData.Riesgo
            : null,
        num_electronic:
          createCreditUserData && createCreditUserData.NoElectronico
            ? createCreditUserData.NoElectronico
            : null,
        actual_taker:
          createCreditUserData && createCreditUserData.TomadorReal
            ? createCreditUserData.TomadorReal
            : null,
        doc_insured:
          createCreditUserData && createCreditUserData.Doc_Asegurado
            ? createCreditUserData.Doc_Asegurado
            : null,
        doc_taker:
          createCreditUserData && createCreditUserData.Doc_Tomador
            ? createCreditUserData.Doc_Tomador
            : null,
        doc_beneficiary:
          createCreditUserData && createCreditUserData.Doc_Beneficiario
            ? createCreditUserData.Doc_Beneficiario
            : null,
      });
    }

    if (
      location.pathname ===
      "/admin/crear-credito/formulario-renovacion-confirmar"
    ) {
      const capitalizeFirstLetters = (str) => {
        return str.replace(/\b\w/g, (match) => match.toUpperCase());
      };

      const dataFromLS = JSON.parse(localStorage.getItem("data"));

      setFormData({
        req_type: inputData.type,
        first_name:
          dataFromLS && dataFromLS.nombres ? dataFromLS.nombres : null,
        last_name:
          dataFromLS && dataFromLS.apellidos ? dataFromLS.apellidos : "N/A",
        doc_type:
          dataFromLS && dataFromLS.tipo_documento
            ? dataFromLS.tipo_documento
            : null,
        num_document:
          dataFromLS && dataFromLS.numero_doc ? dataFromLS.numero_doc : null,
        birth_department: createCreditUserData?.DepartamentoDeNacimiento
          ? createCreditUserData.DepartamentoDeNacimiento
          : null,
        birth_place:
          createCreditUserData && createCreditUserData.CiudadDeNacimiento
            ? createCreditUserData.CiudadDeNacimiento
            : null,
        issuance_department: createCreditUserData?.DepartamentoDeExpedicion
          ? createCreditUserData.DepartamentoDeExpedicion
          : null,
        issuance_place:
          createCreditUserData && createCreditUserData.CiudadDeExpedicion
            ? createCreditUserData.CiudadDeExpedicion
            : null,
        date_issuance:
          createCreditUserData && createCreditUserData.FechaExpedicion
            ? createCreditUserData.FechaExpedicion
            : null,
        birthdate:
          createCreditUserData && createCreditUserData.FechaNacimiento
            ? createCreditUserData.FechaNacimiento
            : null,
        genre: createCreditUserData?.Sexo ?? null,
        email:
          dataFromLS && dataFromLS.correo_electronico
            ? dataFromLS.correo_electronico
            : null,
        phone:
          dataFromLS && dataFromLS.cel_titular_credito
            ? dataFromLS.cel_titular_credito
            : null,
        job:
          dataFromLS && dataFromLS.ocupacion_titular_credito
            ? dataFromLS.ocupacion_titular_credito
            : null,
        salary:
          dataFromLS && dataFromLS.ingresos_titular_del_credito
            ? dataFromLS.ingresos_titular_del_credito
            : null,
        country: "",
        department: "",
        city:
          dataFromLS && dataFromLS.ciudad_residencia
            ? dataFromLS.ciudad_residencia
            : null,
        address:
          dataFromLS && dataFromLS.direccion_residencia
            ? dataFromLS.direccion_residencia
            : null,
        num_policy:
          createCreditUserData && createCreditUserData.No_Poliza
            ? createCreditUserData.No_Poliza
            : "",
        insurer_place:
          createCreditUserData && createCreditUserData.Idsucursal
            ? createCreditUserData.Idsucursal
            : null,
        insurer:
          createCreditUserData && createCreditUserData.Aseguradora
            ? createCreditUserData.Aseguradora
            : "",
        name_broker: "",
        broker:
          dataFromLS && dataFromLS.asesor_intermediario
            ? dataFromLS.asesor_intermediario
            : "",
        plate:
          createCreditUserData && createCreditUserData.Placa
            ? createCreditUserData.Placa
            : "",
        init_term:
          createCreditUserData && createCreditUserData.Vig_inicial
            ? createCreditUserData.Vig_inicial
            : "",
        total_annual:
          createCreditUserData && createCreditUserData.Prima_Total
            ? createCreditUserData.Prima_Total
            : "",
        init_credit:
          createCreditUserData && createCreditUserData.Abono_Inicial
            ? createCreditUserData.Abono_Inicial
            : null,
        num_shares: "",
        credit_type: "",
        line:
          createCreditUserData && createCreditUserData.Linea
            ? createCreditUserData.Linea
            : null,
        agent: null,
        brokerage_income:
          createCreditUserData && createCreditUserData.ing_Intermediario
            ? createCreditUserData.ing_Intermediario
            : null,
        is_new:
          createCreditUserData && createCreditUserData.vehiculo0kms
            ? createCreditUserData.vehiculo0kms
            : "false",
        observation_appendix:
          dataFromLS && dataFromLS.ObservacionesAnexo
            ? dataFromLS.ObservacionesAnexo
            : null,
        appendix: createCreditUserData?.Anexo ?? null,
        net_premium:
          createCreditUserData && createCreditUserData.PrimaNetaHDI
            ? createCreditUserData.PrimaNetaHDI
            : null,
        num_certificate:
          createCreditUserData && createCreditUserData.NoCertificado
            ? createCreditUserData.NoCertificado
            : null,
        num_risk:
          createCreditUserData && createCreditUserData.Riesgo
            ? createCreditUserData.Riesgo
            : null,
        num_electronic:
          createCreditUserData && createCreditUserData.NoElectronico
            ? createCreditUserData.NoElectronico
            : null,
        actual_taker:
          createCreditUserData && createCreditUserData.TomadorReal
            ? createCreditUserData.TomadorReal
            : null,
        doc_insured:
          createCreditUserData && createCreditUserData.Doc_Asegurado
            ? createCreditUserData.Doc_Asegurado
            : null,
        doc_taker:
          createCreditUserData && createCreditUserData.Doc_Tomador
            ? createCreditUserData.Doc_Tomador
            : null,
        doc_beneficiary:
          createCreditUserData && createCreditUserData.Doc_Beneficiario
            ? createCreditUserData.Doc_Beneficiario
            : null,
      });
    }
    // eslint-disable-next-line
  }, [createCreditUserData]);

  useEffect(() => {
    if (location.pathname === "/admin/crear-credito/formulario-confirmar") {
      switch (inputData.type) {
        case "Nuevo":
          setFormData({
            req_type: inputData.type,
            first_name: "",
            last_name: "",
            doc_type: "",
            num_document: "",
            birthdate: "",
            genre: "",
            email: "",
            phone: "",
            agent: "",
            job: "",
            salary: "",
            country: "",
            department: "",
            city: "",
            address: "",
            num_policy: "",
            insurer_place: "",
            insurer: "",
            name_broker: "",
            nit_broker: "",
            broker: "",
            plate: "",
            init_term: "",
            total_annual: "",
            init_credit: "",
            num_shares: "",
            credit_type: "",
            brokerage_income: "",
            is_new: "false",
          });
          break;
        case "Renovación":
          setFormData({
            req_type: inputData.type,
            first_name: "",
            last_name: "",
            doc_type: "",
            agent: "",
            num_document: "",
            num_policy: "",
            insurer: "",
            name_broker: "",
            nit_broker: "",
            broker: "",
            plate: "",
            init_term: "",
            total_annual: "",
            init_credit: "",
            num_shares: "",
            credit_type: "",
            brokerage_income: "",
            is_new: "false",
          });
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const selectDept = document.getElementById("birth_department");

    if (selectDept) {
      try {
        fetch(
          `${BACKEND_API}/api/departament-city?id=${formData.birth_place}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then(({ data }) => {
            if (data.Departamento) {
              setFormData({
                ...formData,
                birth_department: data.Departamento[0].Id,
              });

              const index = Array.from(selectDept.options).findIndex(
                (option) => option.value === data.Departamento[0].Id
              );

              selectDept.selectedIndex = index;
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
    // eslint-disable-next-line
  }, [formData?.birth_place]);

  useEffect(() => {
    const selectDeptIssuance = document.getElementById("issuance_department");

    if (selectDeptIssuance) {
      try {
        fetch(
          `${BACKEND_API}/api/departament-city?id=${formData.issuance_place}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then(({ data }) => {
            if (data.Departamento) {
              setFormData({
                ...formData,
                issuance_department: data.Departamento[0].Id,
              });

              const index = Array.from(selectDeptIssuance.options).findIndex(
                (option) => option.value === data.Departamento[0].Id
              );

              selectDeptIssuance.selectedIndex = index;
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
    // eslint-disable-next-line
  }, [formData?.issuance_place]);

  useEffect(() => {
    const selectCity = document.getElementById("birth_place");

    if (selectCity) {
      try {
        const body = {
          id_department: formData.birth_department,
          get_cities: true,
          get_departments: false,
        };
        fetch("https://back-crediseguro.com/getLocation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Ciudad) {
              selectCity.innerHTML = "";

              const noneOption = document.createElement("option");
              noneOption.text = "--Ninguno--";
              noneOption.value = "";

              selectCity.appendChild(noneOption);

              data.Ciudad.map((city) => {
                const option = document.createElement("option");
                option.text = city.Nombre;
                option.value = city.Id;
                selectCity.appendChild(option);

                const optionsArray = Array.from(selectCity.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectCity.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectCity.appendChild(option);
                });
              });

              const index = Array.from(selectCity.options).findIndex(
                (option) => option.value === formData.birth_place
              );

              selectCity.selectedIndex = index;
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
    // eslint-disable-next-line
  }, [formData?.birth_department]);

  useEffect(() => {
    const selectCityIssuance = document.getElementById("issuance_place");

    if (selectCityIssuance) {
      try {
        selectCityIssuance.innerHTML = "";

        const body = {
          id_department: formData.issuance_department,
          get_cities: true,
          get_departments: false,
        };
        fetch("https://back-crediseguro.com/getLocation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Ciudad) {
              const noneOption = document.createElement("option");
              noneOption.text = "--Ninguno--";
              noneOption.value = "";

              selectCityIssuance.appendChild(noneOption);

              data.Ciudad.map((city) => {
                const option = document.createElement("option");
                option.text = city.Nombre;
                option.value = city.Id;
                selectCityIssuance.appendChild(option);

                const optionsArray = Array.from(selectCityIssuance.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectCityIssuance.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectCityIssuance.appendChild(option);
                });
              });

              const index = Array.from(selectCityIssuance.options).findIndex(
                (option) => option.value === formData.issuance_place
              );

              selectCityIssuance.selectedIndex = index;
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
  }, [formData?.issuance_department]);

  useEffect(() => {
    switch (location.pathname) {
      case "/admin/crear-credito/verificar-datos":
        const userData = JSON.parse(localStorage.getItem("userData"));

        setFormData({
          ...formData,
          phone: userData.phone,
          email: userData.email,
        });

        break;
      case "/admin/crear-credito/formulario-renovacion-confirmar":
        if (stepNumber === 0) {
          const selectInsurer = document.getElementById("insurer");

          const insuranceIdLS = localStorage.getItem("insurance_id");

          const isFromRenovationTable =
            localStorage.getItem("fromRenovationTable") || false;

          try {
            fetch(`${BACKEND_API}/api/insurance-companies`, {
              method: "GET",
              credentials: "include",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
              },
            })
              .then((res) => res.json())
              .then(({ data }) => {
                const selectedInsurer = data.filter(
                  (item) => item.IdAseguradora === insuranceIdLS
                );

                selectedInsurer.map((insurer) => {
                  const option = document.createElement("option");
                  option.text = insurer.NombreAseguradora;
                  option.value = insurer.IdAseguradora;
                  selectInsurer.appendChild(option);

                  const optionsArray = Array.from(selectInsurer.options);

                  optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                  selectInsurer.innerHTML = "";

                  return optionsArray.forEach((option) => {
                    selectInsurer.appendChild(option);
                  });
                });
                try {
                  const selectInsurerPlace =
                    document.getElementById("insurer_place");

                  fetch(`${BACKEND_API}/api/subsidiary?id=${insuranceIdLS}`, {
                    method: "GET",
                    credentials: "include",
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-type": "application/json",
                    },
                  })
                    .then((res) => res.json())
                    .then(({ data }) => {
                      if (data.EstadoConsulta === "Exitoso") {
                        data.Sucursal.map((insurerPlace) => {
                          const option = document.createElement("option");
                          option.text = insurerPlace.Nombre;
                          option.value = insurerPlace.Id;
                          selectInsurerPlace.appendChild(option);

                          const optionsArray = Array.from(
                            selectInsurerPlace.options
                          );

                          optionsArray.sort((a, b) =>
                            a.text.localeCompare(b.text)
                          );

                          selectInsurerPlace.innerHTML = "";

                          return optionsArray.forEach((option) => {
                            selectInsurerPlace.appendChild(option);
                          });
                        });
                      }
                    });
                } catch (err) {
                  console.log(err);
                }
              });
          } catch (err) {
            console.log(err);
          }

          if (isFromRenovationTable) {
            try {
              const selectBroker = document.getElementById("broker");

              fetch(`${BACKEND_API}/api/advisors`, {
                method: "GET",
                credentials: "include",
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-type": "application/json",
                },
              })
                .then((res) => res.json())
                .then(({ data }) => {
                  data.map((broker) => {
                    const option = document.createElement("option");
                    option.text = broker.NombreAsesor;
                    option.value = broker.IdAsesor;
                    selectBroker.appendChild(option);

                    const optionsArray = Array.from(selectBroker.options);

                    return optionsArray.sort((a, b) =>
                      a.text.localeCompare(b.text)
                    );
                  });
                });
            } catch (err) {
              console.log(err);
            }
          }

          const isAdminPreview = localStorage.getItem("adminPreview");
          const selectAgent = document.getElementById("agent");

          if (isAdminPreview && selectAgent) {
            try {
              fetch(`${BACKEND_API}/api/agent`, {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              })
                .then((res) => res.json())
                .then((data) => {
                  if (data.message === "informacion agentes") {
                    // Elimina todas las opciones anteriores, excepto la predeterminada
                    selectAgent.innerHTML =
                      '<option value="">--Ninguno--</option>';

                    const agentsOptions = data.data.map((agent) => {
                      const option = document.createElement("option");
                      option.text = agent.name;
                      option.value = `${agent.document}-${agent.name}`;
                      return option;
                    });

                    // Ordenar las opciones alfabéticamente por texto
                    agentsOptions.sort((a, b) => a.text.localeCompare(b.text));

                    // Añadir las opciones ordenadas al select
                    agentsOptions.forEach((option) => {
                      selectAgent.appendChild(option);
                    });
                  }
                });
            } catch (err) {
              console.log(err);
            }
          }

          const selectLine = document.getElementById("line");

          try {
            fetch(`${BACKEND_API}/api/line`, {
              method: "GET",
              credentials: "include",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
              },
            })
              .then((res) => res.json())
              .then(({ data }) => {
                if (data.length > 0) {
                  data.map((line) => {
                    const option = document.createElement("option");
                    option.text = line;
                    option.value = line;
                    selectLine.appendChild(option);

                    const optionsArray = Array.from(selectLine.options);

                    optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                    selectLine.innerHTML = "";

                    optionsArray.forEach((option) => {
                      selectLine.appendChild(option);
                    });

                    return null;
                  });
                }
              });
          } catch (err) {
            console.log(err);
          }
        }
        break;
      case "/admin/crear-credito/formulario-confirmar":
        if (stepNumber === 0 && inputData.type === "Nuevo") {
          const selectDept = document.getElementById("birth_department");

          const body = {
            id_department: "",
            get_cities: false,
            get_departments: true,
          };
          fetch("https://back-crediseguro.com/getLocation", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          })
            .then((res) => res.json())
            .then((data) => {
              data.Departamento.map((dept) => {
                const option = document.createElement("option");
                option.text = dept.Nombre;
                option.value = dept.Id;
                selectDept.appendChild(option);

                const optionsArray = Array.from(selectDept.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectDept.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectDept.appendChild(option);
                });
              });
            });

          const selectDeptIssuance = document.getElementById(
            "issuance_department"
          );

          const bodyIssuance = {
            id_department: "",
            get_cities: false,
            get_departments: true,
          };

          fetch("https://back-crediseguro.com/getLocation", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyIssuance),
          })
            .then((res) => res.json())
            .then((data) => {
              data.Departamento.map((dept) => {
                const option = document.createElement("option");
                option.text = dept.Nombre;
                option.value = dept.Id;
                selectDeptIssuance.appendChild(option);

                const optionsArray = Array.from(selectDeptIssuance.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectDeptIssuance.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectDeptIssuance.appendChild(option);
                });
              });
            });

          const isAdminPreview = localStorage.getItem("adminPreview");
          const selectAgent = document.getElementById("agent");

          if (isAdminPreview && selectAgent) {
            try {
              fetch(`${BACKEND_API}/api/agent`, {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              })
                .then((res) => res.json())
                .then((data) => {
                  if (data.message === "informacion agentes") {
                    // Elimina todas las opciones anteriores, excepto la predeterminada
                    selectAgent.innerHTML =
                      '<option value="">--Ninguno--</option>';

                    const agentsOptions = data.data.map((agent) => {
                      const option = document.createElement("option");
                      option.text = agent.name;
                      option.value = `${agent.document}-${agent.name}`;
                      return option;
                    });

                    // Ordenar las opciones alfabéticamente por texto
                    agentsOptions.sort((a, b) => a.text.localeCompare(b.text));

                    // Añadir las opciones ordenadas al select
                    agentsOptions.forEach((option) => {
                      selectAgent.appendChild(option);
                    });
                  }
                });
            } catch (err) {
              console.log(err);
            }
          }
        }

        if (stepNumber === 1) {
          const selectInsurer = document.getElementById("insurer");

          const insuranceIdLS = localStorage.getItem("insurance_id");

          try {
            fetch(`${BACKEND_API}/api/insurance-companies`, {
              method: "GET",
              credentials: "include",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
              },
            })
              .then((res) => res.json())
              .then(({ data }) => {
                const selectedInsurer = data.filter(
                  (item) => item.IdAseguradora === insuranceIdLS
                );

                selectedInsurer.map((insurer) => {
                  const option = document.createElement("option");
                  option.text = insurer.NombreAseguradora;
                  option.value = insurer.IdAseguradora;
                  selectInsurer.appendChild(option);

                  const optionsArray = Array.from(selectInsurer.options);

                  optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                  selectInsurer.innerHTML = "";

                  return optionsArray.forEach((option) => {
                    selectInsurer.appendChild(option);
                  });
                });
                try {
                  const selectInsurerPlace =
                    document.getElementById("insurer_place");

                  fetch(`${BACKEND_API}/api/subsidiary?id=${insuranceIdLS}`, {
                    method: "GET",
                    credentials: "include",
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-type": "application/json",
                    },
                  })
                    .then((res) => res.json())
                    .then(({ data }) => {
                      if (data.EstadoConsulta === "Exitoso") {
                        data.Sucursal.map((insurerPlace) => {
                          const option = document.createElement("option");
                          option.text = insurerPlace.Nombre;
                          option.value = insurerPlace.Id;
                          selectInsurerPlace.appendChild(option);

                          const optionsArray = Array.from(
                            selectInsurerPlace.options
                          );

                          optionsArray.sort((a, b) =>
                            a.text.localeCompare(b.text)
                          );

                          selectInsurerPlace.innerHTML = "";

                          optionsArray.forEach((option) => {
                            selectInsurerPlace.appendChild(option);
                          });

                          if (
                            createCreditUserData.Idsucursal &&
                            createCreditUserData.Idsucursal === insurerPlace.Id
                          ) {
                            selectInsurerPlace.value =
                              createCreditUserData.Idsucursal;
                          }

                          return null;
                        });
                      }
                    });
                } catch (err) {
                  console.log(err);
                }
              });
          } catch (err) {
            console.log(err);
          }

          const selectLine = document.getElementById("line");

          try {
            fetch(`${BACKEND_API}/api/line`, {
              method: "GET",
              credentials: "include",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
              },
            })
              .then((res) => res.json())
              .then(({ data }) => {
                if (data.length > 0) {
                  data.map((line) => {
                    const option = document.createElement("option");
                    option.text = line;
                    option.value = line;
                    selectLine.appendChild(option);

                    const optionsArray = Array.from(selectLine.options);

                    optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                    selectLine.innerHTML = "";

                    optionsArray.forEach((option) => {
                      selectLine.appendChild(option);
                    });

                    return null;
                  });
                }
              });
          } catch (err) {
            console.log(err);
          }
        }

        break;
      case "/admin/crear-credito/formulario-renovacion":
      case "/admin/crear-credito/formulario":
        if (stepNumber === 0 && inputData.type === "Nuevo") {
          const selectDept = document.getElementById("department");

          const body = {
            id_department: "",
            get_cities: false,
            get_departments: true,
          };
          fetch("https://back-crediseguro.com/getLocation", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          })
            .then((res) => res.json())
            .then((data) => {
              data.Departamento.map((dept) => {
                const option = document.createElement("option");
                option.text = dept.Nombre;
                option.value = dept.Id;
                selectDept.appendChild(option);

                const optionsArray = Array.from(selectDept.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectDept.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectDept.appendChild(option);
                });
              });
            });
          try {
          } catch (err) {
            console.log(err);
          }

          try {
            const selectBroker = document.getElementById("broker");

            fetch(`${BACKEND_API}/api/advisors`, {
              method: "GET",
              credentials: "include",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json",
              },
            })
              .then((res) => res.json())
              .then(({ data }) => {
                data.map((broker) => {
                  const option = document.createElement("option");
                  option.text = broker.NombreAsesor;
                  option.value = broker.IdAsesor;
                  selectBroker.appendChild(option);

                  const optionsArray = Array.from(selectBroker.options);

                  return optionsArray.sort((a, b) =>
                    a.text.localeCompare(b.text)
                  );
                });
              });
          } catch (err) {
            console.log(err);
          }
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [stepNumber]);

  const addErrorToLocalStorage = (errorCode) => {
    if (!errorListFromLS?.includes(errorCode)) {
      errorListFromLS?.push(errorCode);
      localStorage.setItem("error_list", JSON.stringify(errorListFromLS));
    }
  };

  const handleForm = (e) => {
    setModifiedField([...modifiedField, e.target.name]);

    if (e.target.title === "text") {
      if (e.target.name === "plate") {
        e.target.value = e.target.value
          .replace(/\s/g, "")
          .toUpperCase()
          .substring(0, 6);
      } else {
        const inputValue = e.target.value.trimStart();
        const lowercaseValue = inputValue.toLowerCase();

        e.target.value = lowercaseValue
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }

      if (e.target.value.trim() === "") {
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.title === "select") {
      if (e.target.name === "num_shares") {
        const totalAnnualSubsWithInitCreditValue =
          formData?.total_annual - formData?.init_credit;

        if (
          totalAnnualSubsWithInitCreditValue >= 1000001 &&
          e.target.value >= 1 &&
          e.target.value <= 1
        ) {
          e.target.nextElementSibling.innerText =
            "Si la prima total anual es mayor a 1'000.001, el número de cuotas debe ser entre 2 a 11 meses.";
          e.target.nextElementSibling.classList.remove("hide");
        } else if (
          totalAnnualSubsWithInitCreditValue >= 500001 &&
          totalAnnualSubsWithInitCreditValue <= 1000000 &&
          ((userData.document === "900697686" && e.target.value < 7) ||
            (userData.document !== "900697686" && e.target.value < 10))
        ) {
          e.target.nextElementSibling.innerText = `Si la prima total anual es entre 500.001 y 1'000.000, el número de cuotas no debe ser menor a ${
            userData.document === "900697686" ? "7" : "10"
          } meses.`;
          e.target.nextElementSibling.classList.remove("hide");
        } else {
          e.target.nextElementSibling.classList.add("hide");
        }
      } else {
        if (e.target.value.trim() === "") {
          e.target.nextElementSibling.classList.remove("hide");
        } else {
          e.target.nextElementSibling.classList.add("hide");
        }
      }
    }

    if (e.target.title === "number") {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");

      if (e.target.name === "init_credit") {
        e.target.value = parseInt(e.target.value, 10);

        if (isNaN(e.target.value) || e.target.value > 10000000) {
          e.target.value = isNaN(e.target.value) ? 0 : 10000000;
        }
      }

      if (e.target.name === "total_annual") {
        if (e.target.value <= 500000) {
          e.target.nextElementSibling.innerText =
            "La prima total anual debe ser mayor a 500.000.";
          setTimeout(() => {
            e.target.nextElementSibling.classList.remove("hide");
          }, 10);
        }
      }

      if (e.target.value.trim() === "") {
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.title === "date") {
      const birthdate = new Date(e.target.value);
      const today = new Date();
      const age = today.getFullYear() - birthdate.getFullYear();

      if (
        (e.target.name === "birthdate" && age < 18) ||
        birthdate.getFullYear() < 1900
      ) {
        e.target.nextElementSibling.innerText = "Debes ser mayor de edad";
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.name === "init_term") {
      const currentDate = new Date(e.target.value);
      const limitDate = new Date();
      const limitDateMin = new Date();

      limitDateMin.setMonth(limitDateMin.getMonth() - 2);

      limitDate.setDate(limitDate.getDate() + 45);

      if (currentDate > limitDate || currentDate < limitDateMin) {
        e.target.nextElementSibling.innerText =
          "La vigencia inicial no debe ser mayor a 45 dias, ni anterior a 2 meses";
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.title === "email") {
      const regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!regexEmail.test(e.target.value)) {
        e.target.nextElementSibling.innerText = "Ingresa un correo valido";
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.title === "phone") {
      e.target.value = e.target.value.replace(/\s/g, "").replace(/\D/g, "");

      if (e.target.value.length > 10) {
        e.target.value = e.target.value.substring(0, 10);
      }

      if (e.target.value.trim() === "" || e.target.value.length < 10) {
        e.target.nextElementSibling.innerText = "Ingresa un número valido";
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        if (
          e.target.name === "00N5G00000WiqJe" &&
          e.target.value === formData["00N5G00000WiqHn"]
        ) {
          e.target.nextElementSibling.innerText =
            "El número no puede ser igual";
          e.target.nextElementSibling.classList.remove("hide");
        } else {
          e.target.nextElementSibling.classList.add("hide");
        }
      }
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target.closest("form");

    const formId = localStorage.getItem("form_id");

    const token = localStorage.getItem("token");

    const dataFromLS = JSON.parse(localStorage.getItem("data") || "{}");

    switch (location.pathname) {
      case "/admin/crear-credito/verificar-datos":
        const verifyUserData = JSON.parse(localStorage.getItem("userData"));

        try {
          setLoading(true);

          fetch(
            `${BACKEND_API}/api/document-client?document=${verifyUserData.num_doc}`,
            {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Documents") {
                const userData = {
                  phone:
                    verifyUserData.phone !== formData.phone
                      ? formData.phone
                      : data.data.Phone,
                  email:
                    verifyUserData.email !== formData.email
                      ? formData.email
                      : data.data.Email,
                  num_doc: verifyUserData.num_doc,
                  full_name: verifyUserData.full_name,
                };

                localStorage.setItem("userData", JSON.stringify(userData));
                localStorage.setItem("latestStep", "verify-data");
                history("/admin/crear-credito/formulario-renovacion");
              }
            })
            .finally(() => {
              setLoading(false);
            });
        } catch (err) {
          console.log(err);
        }

        break;
      case "/admin/crear-credito/validar-documento":
        setLoading(true);

        localStorage.setItem("error_list", JSON.stringify([]));

        try {
          fetch(
            `${BACKEND_API}/api/validate-status-quotas?noDocumento=${formData.num_document}`,
            {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
            .then((res) => res.json())
            .then((data) => {
              if (data?.message === "informacion creditos") {
                if (
                  data.data?.RespConsultaVrPendiente ||
                  data.data?.RespConsultamora
                ) {
                  const uuid = uuidv4();
                  const valuesArr = uuid.split("-");

                  const id = valuesArr[0] + valuesArr[1];

                  const respRequestValuePending =
                    data.data?.RespConsultaVrPendiente;

                  const respRequestDebt = data.data?.RespConsultamora;

                  try {
                    const body = {
                      vig_inicial: null,
                      sexo: null,
                      prima_total: null,
                      placa: null,
                      ocupacion_titular_credito: null,
                      numero_doc: formData.num_document,
                      Tipo_Documento: formData.doc_type,
                      nombres: null,
                      no_poliza: null,
                      no_cuotas: null,
                      linea: null,
                      ingresos_titular_del_credito: null,
                      id: id,
                      fecha_nacimiento: null,
                      fecha_expedicion: null,
                      estado_civil: null,
                      departamento_nacimiento: null,
                      departamento_expedicion: null,
                      correo_electronico: null,
                      ciudad_nacimiento: null,
                      ciudad_expedicion: null,
                      cel_titular_credito: null,
                      asesor_intermediario: formData.broker,
                      apellidos: "N/A",
                      abono_inicial: null,
                      id_sucursal: null,
                      ciudad_residencia: null,
                      direccion_residencia: null,
                      es_renovacion: false,
                      vehiculo0kms: false,
                      credito_en_proceso: false,
                      TipoSolicitante: "Persona Natural",
                      novedadesOCR: data.data?.RespConsultaVrPendiente
                        ? "002"
                        : data.data?.RespConsultamora && "003",
                    };

                    fetch(`${BACKEND_API}${inputData.endpoint}`, {
                      method: "PUT",
                      credentials: "include",
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-type": "application/json",
                      },
                      body: JSON.stringify(body),
                    })
                      .then((res) => res.json())
                      .then((data) => {
                        if (data?.message === "informacion actualizada") {
                          setShowPopup(true);
                          setPopupData({
                            title: "Documento no valido para proceso",
                            info: respRequestValuePending
                              ? "Cliente registra saldo pendiente en Crediseguro, por favor solicitar el saldo al correo analistaoperativo@crediseguro.co."
                              : respRequestDebt
                              ? "Cliente registra cuotas en mora en crédito vigente, por favor ponerse al día para dar continuidad al nuevo negocio."
                              : "",
                            type: "error",
                          });
                          setLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } catch (err) {
                    console.log(err);
                  }
                } else {
                  localStorage.setItem("latestStep", "validate-document");

                  const uuid = uuidv4();
                  const valuesArr = uuid.split("-");

                  const id = valuesArr[0] + valuesArr[1];

                  localStorage.setItem("form_id", id);

                  try {
                    const body = {
                      vig_inicial: null,
                      sexo: null,
                      prima_total: null,
                      placa: null,
                      ocupacion_titular_credito: null,
                      numero_doc: null,
                      nombres: null,
                      no_poliza: null,
                      no_cuotas: null,
                      linea: null,
                      ingresos_titular_del_credito: null,
                      id: id,
                      fecha_nacimiento: null,
                      fecha_expedicion: null,
                      estado_civil: null,
                      departamento_nacimiento: null,
                      departamento_expedicion: null,
                      correo_electronico: null,
                      ciudad_nacimiento: null,
                      ciudad_expedicion: null,
                      cel_titular_credito: null,
                      asesor_intermediario: formData.broker,
                      apellidos: null,
                      abono_inicial: null,
                      ciudad_residencia: null,
                      direccion_residencia: null,
                      vehiculo0kms: false,
                      credito_en_proceso: true,
                      TipoSolicitante: "Persona Natural",
                    };

                    localStorage.setItem("data", JSON.stringify(body));
                  } catch (err) {
                    console.log(err);
                  }

                  try {
                    fetch(
                      `https://back-crediseguro.com/getDocument/${formData.num_document}`,
                      {
                        method: "GET",
                      }
                    )
                      .then((res) => res.json())
                      .then((data) => {
                        if (
                          data &&
                          data.message === "Información obtendida exitosamente"
                        ) {
                          try {
                            fetch(
                              `${BACKEND_API}/api/document-client?document=${formData.num_document}`,
                              {
                                method: "GET",
                                credentials: "include",
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            )
                              .then((res) => res.json())
                              .then((data) => {
                                if (data && data.message === "Documents") {
                                  const splittedName =
                                    data.data.Nombre.split(" ");

                                  const creditData = JSON.parse(
                                    localStorage.getItem("data")
                                  );

                                  const newBody = {
                                    ...creditData,
                                    tipo_documento: data.data.Tipodocumento,
                                    nombres: `${splittedName?.[0]} ${splittedName?.[1]}`,
                                    apellidos: splittedName?.[3]
                                      ? `${splittedName[2]} ${splittedName[3]}`
                                      : splittedName?.[2] || "",
                                    numero_doc: data.data.NoDocumento,
                                    cel_titular_credito: data.data.Phone,
                                  };

                                  localStorage.setItem(
                                    "data",
                                    JSON.stringify(newBody)
                                  );
                                }
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          } catch (err) {
                            console.log(err);
                          }

                          localStorage.setItem(
                            "user_document",
                            data.data.NoDocumento
                          );

                          const userData = {
                            phone: data.data.Phone,
                            email: data.data.Email,
                            num_doc: data.data.NoDocumento,
                            full_name: data.data.Nombre,
                          };

                          const body = {
                            vig_inicial: null,
                            sexo: null,
                            prima_total: null,
                            placa: null,
                            ocupacion_titular_credito: null,
                            numero_doc: formData.num_document,
                            Tipo_Documento: formData.doc_type,
                            nombres: null,
                            no_poliza: null,
                            no_cuotas: null,
                            linea: null,
                            ingresos_titular_del_credito: null,
                            id: id,
                            fecha_nacimiento: null,
                            fecha_expedicion: null,
                            estado_civil: null,
                            departamento_nacimiento: null,
                            departamento_expedicion: null,
                            correo_electronico: null,
                            ciudad_nacimiento: null,
                            ciudad_expedicion: null,
                            cel_titular_credito: null,
                            asesor_intermediario: formData.broker,
                            apellidos: "N/A",
                            abono_inicial: null,
                            id_sucursal: null,
                            ciudad_residencia: null,
                            direccion_residencia: null,
                            es_renovacion: false,
                            vehiculo0kms: false,
                            credito_en_proceso: true,
                            TipoSolicitante: "Persona Natural",
                          };

                          fetch(`${BACKEND_API}${inputData.endpoint}`, {
                            method: "PUT",
                            credentials: "include",
                            headers: {
                              Authorization: `Bearer ${token}`,
                              "Content-type": "application/json",
                            },
                            body: JSON.stringify(body),
                          })
                            .then((res) => res.json())
                            .then((data) => console.log("Exitoso!!"));

                          if (formData.credit_type === "renovation") {
                            localStorage.setItem(
                              "userData",
                              JSON.stringify(userData)
                            );
                            localStorage.setItem("processType", "renovation");
                            localStorage.setItem("isCreditInProcess", true);
                            history("/admin/crear-credito/adjuntar-poliza");
                          } else {
                            localStorage.setItem(
                              "userData",
                              JSON.stringify(userData)
                            );
                            localStorage.setItem("processType", "new-credit");
                            localStorage.setItem("isCreditInProcess", true);
                            history("/admin/crear-credito/adjuntar-poliza");
                          }
                          setLoading(false);
                        } else {
                          try {
                            const body = {
                              vig_inicial: null,
                              sexo: null,
                              prima_total: null,
                              placa: null,
                              ocupacion_titular_credito: null,
                              numero_doc: formData.num_document,
                              Tipo_Documento: formData.doc_type,
                              nombres: null,
                              no_poliza: null,
                              no_cuotas: null,
                              linea: null,
                              ingresos_titular_del_credito: null,
                              id: id,
                              fecha_nacimiento: null,
                              fecha_expedicion: null,
                              estado_civil: null,
                              departamento_nacimiento: null,
                              departamento_expedicion: null,
                              correo_electronico: null,
                              ciudad_nacimiento: null,
                              ciudad_expedicion: null,
                              cel_titular_credito: null,
                              asesor_intermediario: formData.broker,
                              apellidos: "N/A",
                              abono_inicial: null,
                              id_sucursal: null,
                              ciudad_residencia: null,
                              direccion_residencia: null,
                              es_renovacion: false,
                              vehiculo0kms: false,
                              credito_en_proceso: true,
                              TipoSolicitante: "Persona Natural",
                            };
                            fetch(`${BACKEND_API}${inputData.endpoint}`, {
                              method: "PUT",
                              credentials: "include",
                              headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-type": "application/json",
                              },
                              body: JSON.stringify(body),
                            })
                              .then((res) => res.json())
                              .then(({ data }) => {
                                if (data.Estado === "Exitoso") {
                                  localStorage.setItem(
                                    "userData",
                                    JSON.stringify({})
                                  );
                                  localStorage.setItem(
                                    "processType",
                                    "new-credit"
                                  );
                                  localStorage.setItem(
                                    "isCreditInProcess",
                                    true
                                  );
                                  history(
                                    "/admin/crear-credito/adjuntar-documento"
                                  );
                                  setLoading(false);
                                }
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          } catch (err) {
                            console.log(err);
                          }
                        }
                      })
                      .catch(() => {
                        localStorage.setItem("userData", JSON.stringify({}));
                        localStorage.setItem("isCreditInProcess", true);
                        localStorage.setItem("processType", "new-credit");
                        history("/admin/crear-credito/adjuntar-documento");
                        setLoading(false);
                      });
                  } catch (err) {
                    console.log(err);
                  }
                }
              }
            })
            .catch((err) => console.error(err));
        } catch (err) {
          console.log(err);
        }

        break;
      case "/admin/crear-credito/adjuntar-anexo":
        try {
          const creditDataFromLocalstorage = JSON.parse(
            localStorage.getItem("data") || "{}"
          );

          const creditData = {
            ...creditDataFromLocalstorage,
            observation_appendix: formData.observation_appendix,
          };

          localStorage.setItem("data", JSON.stringify(creditData));

          setShowPopup(true);
          setPopupData({
            title: "Enviado Exitosamente",
            info: "Tu información ha sido recibida exitosamente.",
            type: "correct",
          });
        } catch (err) {
          console.log(err);
        }
        break;
      case "/admin/crear-credito/formulario-renovacion":
        setLoading(true);
        localStorage.setItem("latestStep", "complement-data-renovation");

        const userDataFromLS = JSON.parse(localStorage.getItem("userData"));

        const creditData = JSON.parse(localStorage.getItem("data"));

        try {
          const body = {
            vig_inicial: null,
            sexo: null,
            prima_total: null,
            placa: null,
            ocupacion_titular_credito: null,
            numero_doc: userDataFromLS?.num_doc
              ? userDataFromLS?.num_doc
              : null,
            nombres: creditData?.nombres ? creditData?.nombres : null,
            no_poliza: null,
            no_cuotas: 1,
            linea: null,
            ingresos_titular_del_credito: null,
            id: formId,
            fecha_nacimiento: null,
            fecha_expedicion: null,
            estado_civil: null,
            departamento_nacimiento: null,
            departamento_expedicion: null,
            correo_electronico: userDataFromLS?.email
              ? userDataFromLS?.email
              : null,
            ciudad_nacimiento: null,
            ciudad_expedicion: null,
            cel_titular_credito: userDataFromLS?.phone
              ? userDataFromLS?.phone
              : null,
            asesor_intermediario: formData.broker,
            apellidos: creditData?.apellidos ? creditData?.apellidos : "N/A",
            abono_inicial: null,
            ciudad_residencia: formData.city,
            direccion_residencia: formData.address,
            ObservacionesAnexo: dataFromLS?.observation_appendix
              ? dataFromLS?.observation_appendix
              : null,
            tipo_documento: creditData?.tipo_documento
              ? creditData?.tipo_documento
              : null,
          };

          localStorage.setItem("data", JSON.stringify(body));
          setTimeout(() => {
            history(inputData.redirect);
          }, 5000);
        } catch (err) {
          console.log(err);
        }
        break;
      case "/admin/crear-credito/formulario":
        setLoading(true);

        localStorage.setItem("latestStep", "complement-data");

        const creditDataSecond = JSON.parse(localStorage.getItem("data"));

        try {
          const body = {
            vig_inicial: null,
            sexo: null,
            prima_total: null,
            placa: null,
            ocupacion_titular_credito: formData.job,
            nombres: creditDataSecond?.nombres,
            numero_doc: creditDataSecond?.numero_doc,
            no_poliza: null,
            no_cuotas: 1,
            linea: null,
            ingresos_titular_del_credito: formData.salary,
            id: formId,
            fecha_nacimiento: null,
            fecha_expedicion: null,
            estado_civil: null,
            departamento_nacimiento: null,
            departamento_expedicion: null,
            correo_electronico: formData.email,
            ciudad_nacimiento: null,
            ciudad_expedicion: null,
            cel_titular_credito: creditDataSecond?.cel_titular_credito,
            asesor_intermediario: formData.broker,
            apellidos: creditDataSecond?.apellidos,
            abono_inicial: formData.init_credit,
            ciudad_residencia: formData.city,
            direccion_residencia: formData.address,
            ObservacionesAnexo: dataFromLS.observation_appendix,
            tipo_documento: creditDataSecond?.tipo_documento,
          };

          localStorage.setItem("data", JSON.stringify(body));

          history(inputData.redirect);
        } catch (err) {
          console.log(err);
        }
        break;
      case "/admin/crear-credito/formulario-renovacion-confirmar":
        const uniqueArrayRenovation = [...new Set(modifiedField)];

        localStorage.setItem(
          "modifiedFields",
          JSON.stringify(uniqueArrayRenovation)
        );

        const renDocument = localStorage.getItem("user_document") || "";
        const docAsegurado = formData.doc_insured?.trim();
        const docTomador = formData.doc_taker?.trim();

        const hasValidDocAsegurado = docAsegurado && docAsegurado.length > 3;
        const hasValidDocTomador = docTomador && docTomador.length > 3;

        const insurerIdRen = localStorage.getItem("insurance_id");

        const inputDateRen = new Date(formData?.init_term);
        const currentDateRen = new Date();

        const differenceInTimeRen =
          currentDateRen.getTime() - inputDateRen.getTime();

        const differenceInDaysRen = Math.floor(
          differenceInTimeRen / (1000 * 60 * 60 * 24)
        );

        if (hasValidDocAsegurado || hasValidDocTomador) {
          if (renDocument !== docAsegurado && renDocument !== docTomador) {
            addErrorToLocalStorage("010");

            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                "El documento ingresado al inicio de la solicitud, no coincide con el No. De Documento de la caratula de la póliza, por favor validar inconsistencia y volver a radicar para dar continuidad.",
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
            setShowPopup(true);
            return;
          }
        }

        const totalAnnualSubsWithInitCreditValueRen =
          formData?.total_annual - formData?.init_credit;

        if (
          (totalAnnualSubsWithInitCreditValueRen >= 1000001 &&
            formData.num_shares >= 1 &&
            formData.num_shares <= 1) ||
          (totalAnnualSubsWithInitCreditValueRen >= 500001 &&
            totalAnnualSubsWithInitCreditValueRen <= 1000000 &&
            ((userData.document === "900697686" && formData.num_shares < 7) ||
              (userData.document !== "900697686" &&
                formData.num_shares < 10))) ||
          totalAnnualSubsWithInitCreditValueRen <= 500000
        ) {
          console.log("Error");
          if (totalAnnualSubsWithInitCreditValueRen <= 500000) {
            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                "Prima total anual no puede ser menor a $500.000, por favor verificar la información ingresada.",
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
          }

          if (
            totalAnnualSubsWithInitCreditValueRen >= 500001 &&
            totalAnnualSubsWithInitCreditValueRen <= 1000000 &&
            ((userData.document === "900697686" && formData.num_shares < 7) ||
              (userData.document !== "900697686" && formData.num_shares < 10))
          ) {
            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                `Si la prima total anual es entre 500.001 y 1'000.000, el número de cuotas no debe ser menor a ${
                  userData.document === "900697686" ? "7" : "10"
                } meses.`,
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
          }

          if (
            totalAnnualSubsWithInitCreditValueRen >= 1000001 &&
            formData.num_shares === "1"
          ) {
            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                `Si la prima total anual es mayor a 1'000.001, el número de cuotas debe ser entre 2 a 11 meses.`,
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
          }

          setShowPopup(true);
        } else {
          try {
            if (
              insurerIdRen === "0013h00000GiwbTAAR" ||
              insurerIdRen === "0013h00000GiwbWAAR" ||
              insurerIdRen === "0013h00000GiwbaAAB" ||
              insurerIdRen === "0013h00000GiwbbAAB" ||
              insurerIdRen === "0013h00000DgV5TAAV"
            ) {
              if (
                formData.doc_taker === "901038608" ||
                formData.doc_taker === "9010386080"
              ) {
                addErrorToLocalStorage("005");
              }
            } else {
              if (
                formData.doc_taker !== "901038608" &&
                formData.doc_taker !== "9010386080"
              ) {
                addErrorToLocalStorage("006");
              }
            }

            if (differenceInDaysRen >= 36) {
              addErrorToLocalStorage("004");
            }

            if (differenceInDaysRen >= 30 && differenceInDaysRen <= 35) {
              addErrorToLocalStorage("009");
            }

            const errorCodeListFromLS =
              JSON.parse(localStorage.getItem("error_list")) || [];

            const allErrorArr = [...errorCodeList, ...errorCodeListFromLS];

            const body = {
              aseguradora: insurerIdRen,
              vig_inicial: formData.init_term,
              sexo: formData.genre,
              prima_total: formData.total_annual,
              placa: formData.plate,
              ocupacion_titular_credito: formData.job,
              numero_doc: formData.num_document,
              nombres: formData.first_name,
              no_poliza: formData.num_policy,
              no_cuotas: formData.num_shares,
              linea: formData.line,
              ingresos_titular_del_credito: formData.salary,
              id: formId,
              fecha_nacimiento: formData.birthdate,
              fecha_expedicion: formData.date_issuance,
              estado_civil: null,
              departamento_nacimiento: formData.birth_department,
              departamento_expedicion: formData.issuance_department,
              correo_electronico: formData.email,
              ciudad_nacimiento: formData.birth_place,
              ciudad_expedicion: formData.issuance_place,
              cel_titular_credito: formData.phone,
              asesor_intermediario: formData.broker,
              apellidos: formData.last_name,
              abono_inicial: formData.init_credit,
              id_sucursal: formData.insurer_place,
              ciudad_residencia: formData.city,
              direccion_residencia: formData.address,
              es_renovacion: true,
              id_solicitante: formData.agent,
              ing_Intermediario: formData.brokerage_income,
              tipo_documento: formData.doc_type ? formData.doc_type : "CC",
              vehiculo0kms: formData.is_new === "true" ? true : false,
              observaciones_anexo: formData.observation_appendix,
              anexo: formData.appendix,
              prima_netaHDI: formData.net_premium,
              no_certificado: formData.num_certificate,
              no_riesgo: formData.num_risk,
              numero_electronico: formData.num_electronic,
              tomador_real: formData.actual_taker,
              credito_en_proceso: false,
              doc_asegurado: formData.doc_insured,
              doc_tomador: formData.doc_taker,
              doc_beneficiario: formData.doc_beneficiary,
              novedadesOCR: allErrorArr.join(","),
              doc_creador: creatorDocument,
              fuente_creacion: isFromWhatsapp
                ? "whatsapp"
                : "portal_intermediario",
            };

            setShowPopup(true);
            setPopupData({
              hasTitle: true,
              title: "Confirmar información",
              isForm: true,
              complementInfo: {
                is_from_whatsapp: isFromWhatsapp,
                difference_in_days: differenceInDaysRen,
                endpoint: inputData.endpoint,
                data: body,
              },
              formField: [
                {
                  key: 1,
                  title: "Nombres*:",
                  defaultValue: formData.first_name,
                  name: "nombres",
                  type: "text",
                  typeVal: "text",
                  isSelect: false,
                },
                {
                  key: 2,
                  title: "Apellidos*:",
                  defaultValue: formData.last_name,
                  name: "apellidos",
                  type: "text",
                  typeVal: "text",
                  isSelect: false,
                },
                {
                  key: 3,
                  title: "No. de Documento*:",
                  defaultValue: formData.num_document,
                  name: "numero_doc",
                  type: "text",
                  typeVal: "number",
                  isSelect: false,
                },
                {
                  key: 4,
                  title: "Aseguradora*:",
                  name: "insurer",
                  isSelect: true,
                  isBlocked: true,
                  hasNoneOption: false,
                  typeVal: "select",
                  options: [],
                },
                {
                  key: 5,
                  title: "No. Póliza*:",
                  defaultValue: formData.num_policy,
                  name: "no_poliza",
                  type: "text",
                  typeVal: "number",
                  isSelect: false,
                },
                {
                  key: 6,
                  title: "Placa*:",
                  defaultValue: formData.plate,
                  name: "placa",
                  type: "text",
                  typeVal: "text",
                  isSelect: false,
                },
                {
                  key: 7,
                  title: "Prima Total Anual*:",
                  defaultValue: formData.total_annual,
                  name: "prima_total",
                  type: "text",
                  typeVal: "number",
                  isSelect: false,
                },
                {
                  key: 8,
                  title: "Vigencia Inicial*:",
                  defaultValue: formData.init_term,
                  name: "vig_inicial",
                  type: "date",
                  typeVal: "date",
                  isSelect: false,
                },
                {
                  key: 9,
                  title: "No. Cuotas*:",
                  defaultValue: formData.num_shares,
                  name: "no_cuotas",
                  typeVal: "select",
                  isSelect: true,
                  isBlocked: false,
                  hasNoneOption: true,
                  options: [
                    {
                      title: "1",
                    },
                    {
                      title: "2",
                    },
                    {
                      title: "3",
                    },
                    {
                      title: "4",
                    },
                    {
                      title: "5",
                    },
                    {
                      title: "6",
                    },
                    {
                      title: "7",
                    },
                    {
                      title: "8",
                    },
                    {
                      title: "9",
                    },
                    {
                      title: "10",
                    },
                    {
                      title: "11",
                    },
                  ],
                },
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [],
            });
          } catch (err) {
            console.log(err);
          }
        }

        break;
      case "/admin/crear-credito/formulario-confirmar":
        const uniqueArray = [...new Set(modifiedField)];

        localStorage.setItem("modifiedFields", JSON.stringify(uniqueArray));

        const insurerId = localStorage.getItem("insurance_id");

        const inputDate = new Date(formData?.init_term);

        const currentDate = new Date();

        const differenceInTime = currentDate.getTime() - inputDate.getTime();

        const differenceInDays = Math.floor(
          differenceInTime / (1000 * 60 * 60 * 24)
        );

        const totalAnnualSubsWithInitCreditValue =
          formData?.total_annual - formData?.init_credit;

        if (
          (totalAnnualSubsWithInitCreditValue >= 1000001 &&
            formData.num_shares >= 1 &&
            formData.num_shares <= 1) ||
          (totalAnnualSubsWithInitCreditValue >= 500001 &&
            totalAnnualSubsWithInitCreditValue <= 1000000 &&
            ((userData.document === "900697686" && formData.num_shares < 7) ||
              (userData.document !== "900697686" &&
                formData.num_shares < 10))) ||
          totalAnnualSubsWithInitCreditValue <= 500000
        ) {
          console.log("Error");
          if (totalAnnualSubsWithInitCreditValue <= 500000) {
            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                "Prima total anual no puede ser menor a $500.000, por favor verificar la información ingresada.",
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
          }

          if (
            totalAnnualSubsWithInitCreditValue >= 500001 &&
            totalAnnualSubsWithInitCreditValue <= 1000000 &&
            ((userData.document === "900697686" && formData.num_shares < 7) ||
              (userData.document !== "900697686" && formData.num_shares < 10))
          ) {
            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                `Si la prima total anual es entre 500.001 y 1'000.000, el número de cuotas no debe ser menor a ${
                  userData.document === "900697686" ? "7" : "10"
                } meses.`,
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
          }

          if (
            totalAnnualSubsWithInitCreditValue >= 1000001 &&
            formData.num_shares === "1"
          ) {
            setPopupData({
              hasTitle: true,
              hasInfoArr: true,
              title: "",
              infoArr: [
                `Si la prima total anual es mayor a 1'000.001, el número de cuotas debe ser entre 2 a 11 meses.`,
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [
                {
                  page: "login",
                  type: "redirect",
                  action: "close-popup",
                  text: "Cerrar",
                  title: "cerrar",
                  redirect: "/admin/crear-credito/formulario-confirmar",
                },
              ],
            });
          }

          setShowPopup(true);
        } else {
          try {
            if (
              insurerId === "0013h00000GiwbTAAR" ||
              insurerId === "0013h00000GiwbWAAR" ||
              insurerId === "0013h00000GiwbaAAB" ||
              insurerId === "0013h00000GiwbbAAB" ||
              insurerId === "0013h00000DgV5TAAV"
            ) {
              if (
                formData.doc_taker === "901038608" ||
                formData.doc_taker === "9010386080"
              ) {
                addErrorToLocalStorage("005");
              }
            } else {
              if (
                formData.doc_taker !== "901038608" &&
                formData.doc_taker !== "9010386080"
              ) {
                addErrorToLocalStorage("006");
              }
            }

            if (differenceInDays >= 36) {
              addErrorToLocalStorage("004");
            }

            if (differenceInDays >= 30 && differenceInDays <= 35) {
              addErrorToLocalStorage("009");
            }

            const errorCodeListFromLS = JSON.parse(
              localStorage.getItem("error_list")
            );

            const deletedRepeatedErrorCode = errorCodeListFromLS.filter(
              (errorCode, index) =>
                errorCodeListFromLS.indexOf(errorCode) === index
            );

            const allErrorArr = [...errorCodeList, deletedRepeatedErrorCode];

            const body = {
              aseguradora: insurerId,
              vig_inicial: formData.init_term,
              sexo: formData.genre,
              prima_total: formData.total_annual,
              placa: formData.plate,
              ocupacion_titular_credito: formData.job,
              numero_doc: formData.num_document,
              nombres: formData.first_name,
              no_poliza: formData.num_policy,
              no_cuotas: formData.num_shares,
              linea: formData.line,
              ingresos_titular_del_credito: formData.salary,
              id: formId,
              fecha_nacimiento: formData.birthdate,
              fecha_expedicion: formData.date_issuance,
              estado_civil: null,
              departamento_nacimiento: formData.birth_department,
              departamento_expedicion: formData.issuance_department,
              correo_electronico: formData.email,
              ciudad_nacimiento: formData.birth_place,
              ciudad_expedicion: formData.issuance_place,
              cel_titular_credito: formData.phone,
              asesor_intermediario: formData.broker,
              apellidos: formData.last_name,
              abono_inicial: formData.init_credit,
              id_sucursal: formData.insurer_place,
              ciudad_residencia: formData.city,
              direccion_residencia: formData.address,
              es_renovacion: false,
              id_solicitante: formData.agent,
              ing_Intermediario: formData.brokerage_income,
              tipo_documento: formData.doc_type ? formData.doc_type : "CC",
              vehiculo0kms: formData.is_new === "true" ? true : false,
              observaciones_anexo: formData.observation_appendix,
              anexo: formData.appendix,
              prima_netaHDI: formData.net_premium,
              no_certificado: formData.num_certificate,
              no_riesgo: formData.num_risk,
              numero_electronico: formData.num_electronic,
              tomador_real: formData.actual_taker,
              credito_en_proceso: false,
              doc_asegurado: formData.doc_insured,
              doc_tomador: formData.doc_taker,
              doc_beneficiario: formData.doc_beneficiary,
              novedadesOCR: allErrorArr.join(","),
              doc_creador: creatorDocument,
              fuente_creacion: isFromWhatsapp
                ? "whatsapp"
                : "portal_intermediario",
            };

            setShowPopup(true);
            setPopupData({
              hasTitle: true,
              title: "Confirmar información",
              isForm: true,
              complementInfo: {
                is_from_whatsapp: isFromWhatsapp,
                difference_in_days: differenceInDays,
                endpoint: inputData.endpoint,
                data: body,
              },
              formField: [
                {
                  key: 1,
                  title: "Nombres*:",
                  defaultValue: formData.first_name,
                  name: "nombres",
                  type: "text",
                  typeVal: "text",
                  isSelect: false,
                },
                {
                  key: 2,
                  title: "Apellidos*:",
                  defaultValue: formData.last_name,
                  name: "apellidos",
                  type: "text",
                  typeVal: "text",
                  isSelect: false,
                },
                {
                  key: 3,
                  title: "No. de Documento*:",
                  defaultValue: formData.num_document,
                  name: "numero_doc",
                  type: "text",
                  typeVal: "number",
                  isSelect: false,
                },
                {
                  key: 4,
                  title: "Aseguradora*:",
                  name: "insurer",
                  isSelect: true,
                  isBlocked: true,
                  hasNoneOption: false,
                  typeVal: "select",
                  options: [],
                },
                {
                  key: 5,
                  title: "No. Póliza*:",
                  defaultValue: formData.num_policy,
                  name: "no_poliza",
                  type: "text",
                  typeVal: "number",
                  isSelect: false,
                },
                {
                  key: 6,
                  title: "Placa*:",
                  defaultValue: formData.plate,
                  name: "placa",
                  type: "text",
                  typeVal: "text",
                  isSelect: false,
                },
                {
                  key: 7,
                  title: "Prima Total Anual*:",
                  defaultValue: formData.total_annual,
                  name: "prima_total",
                  type: "text",
                  typeVal: "number",
                  isSelect: false,
                },
                {
                  key: 8,
                  title: "Vigencia Inicial*:",
                  defaultValue: formData.init_term,
                  name: "vig_inicial",
                  type: "date",
                  typeVal: "date",
                  isSelect: false,
                },
                {
                  key: 9,
                  title: "No. Cuotas*:",
                  defaultValue: formData.num_shares,
                  name: "no_cuotas",
                  typeVal: "select",
                  isSelect: true,
                  isBlocked: false,
                  hasNoneOption: true,
                  options: [
                    {
                      title: "1",
                    },
                    {
                      title: "2",
                    },
                    {
                      title: "3",
                    },
                    {
                      title: "4",
                    },
                    {
                      title: "5",
                    },
                    {
                      title: "6",
                    },
                    {
                      title: "7",
                    },
                    {
                      title: "8",
                    },
                    {
                      title: "9",
                    },
                    {
                      title: "10",
                    },
                    {
                      title: "11",
                    },
                  ],
                },
              ],
              type: "option",
              showOptionBtn: true,
              btnData: [],
            });
          } catch (err) {
            console.log(err);
          }
        }
        break;
      default:
        break;
    }
  };

  const handleNext = (e) => {
    e.preventDefault();

    const formId = localStorage.getItem("form_id");

    const form = e.target.closest("form"); // Obtén el formulario más cercano

    if (inputData.type === "Nuevo") {
      if (stepNumber === 0) {
        // Validaciones adicionales para el tipo "Nuevo"
        if (!formData.phone || formData.phone.length !== 10) {
          document
            .getElementById("phone")
            .setCustomValidity("Número de teléfono inválido");
        } else {
          document.getElementById("phone").setCustomValidity("");
        }

        if (userData.document !== "900697686") {
          if (formData.num_document?.length < 4) {
            document
              .getElementById("num_document")
              .setCustomValidity(
                "No. De Documento presenta inconsitencia por caracteres, por favor validar."
              );

            setErrorCodeList((prevList) => [...prevList, "007"]);
          } else if (
            createCreditUserData.Doc_Asegurado &&
            createCreditUserData.Doc_Tomador
          ) {
            let sendErrorMessage = false;

            const numDocument = formData.num_document;
            const docAsegurado = createCreditUserData.Doc_Asegurado?.trim();
            const docTomador = createCreditUserData.Doc_Tomador?.trim();

            const hasValidDocAsegurado =
              docAsegurado && docAsegurado.length > 3;
            const hasValidDocTomador = docTomador && docTomador.length > 3;

            if (hasValidDocAsegurado || hasValidDocTomador) {
              if (numDocument !== docAsegurado && numDocument !== docTomador) {
                sendErrorMessage = true;
                document
                  .getElementById("num_document")
                  .setCustomValidity(
                    `No. De Documento de la cedula, no coincide con el No. De Documento de la caratula de la póliza, por favor validar inconsistencia y volver a radicar para dar continuidad.`
                  );
              } else {
                document.getElementById("num_document").setCustomValidity("");
              }
            } else {
              document.getElementById("num_document").setCustomValidity("");
            }

            if (sendErrorMessage) {
              setErrorCodeList((prevList) => [...prevList, "008"]);

              try {
                const body = {
                  vig_inicial: formData.init_term,
                  sexo: formData.genre,
                  prima_total: formData.total_annual,
                  placa: formData.plate,
                  ocupacion_titular_credito: formData.job,
                  numero_doc: formData.num_document,
                  nombres: formData.first_name,
                  no_poliza: formData.num_policy,
                  no_cuotas: formData.num_shares,
                  linea: formData.line,
                  ingresos_titular_del_credito: formData.salary,
                  id: formId,
                  fecha_nacimiento: formData.birthdate,
                  fecha_expedicion: null,
                  estado_civil: null,
                  departamento_nacimiento: null,
                  departamento_expedicion: null,
                  correo_electronico: formData.email,
                  ciudad_nacimiento: formData.birth_place,
                  ciudad_expedicion: null,
                  cel_titular_credito: formData.phone,
                  asesor_intermediario: formData.broker,
                  apellidos: formData.last_name,
                  abono_inicial: formData.init_credit,
                  id_sucursal: formData.insurer_place,
                  ciudad_residencia: formData.city,
                  direccion_residencia: formData.address,
                  es_renovacion: true,
                  id_solicitante: formData.agent,
                  ing_Intermediario: formData.brokerage_income,
                  tipo_documento: formData.doc_type,
                  vehiculo0kms: formData.is_new === "true" ? true : false,
                  ObservacionesAnexo: formData.observation_appendix,
                  anexo: formData.appendix,
                  prima_netaHDI: formData.net_premium,
                  no_certificado: formData.num_certificate,
                  no_riesgo: formData.risk,
                  numero_electronico: formData.num_electronic,
                  novedadesOCR: "008",
                };

                fetch(`${BACKEND_API}${inputData.endpoint}`, {
                  method: "PUT",
                  credentials: "include",
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-type": "application/json",
                  },
                  body: JSON.stringify(body),
                })
                  .then((res) => res.json())
                  .then((data) => console.log("Datos actualizados!!"))
                  .catch((err) => {
                    console.log(err);
                  });
              } catch (err) {
                console.log(err);
              }
            }
          } else {
            document.getElementById("num_document").setCustomValidity("");
          }
        }
      }
    }

    // Si el formulario es válido, avanza al siguiente paso
    if (form.checkValidity()) {
      setStepNumber(stepNumber + 1);
      setProgress(progress + 1);
    } else {
      form.reportValidity();
    }
  };

  const handleDependent = (e, childrenName) => {
    const selectCity = document.getElementById(childrenName);

    if (e.target.id === "department" && childrenName === "city") {
      try {
        selectCity.innerHTML = "";

        const body = {
          id_department: e.target.value,
          get_cities: true,
          get_departments: false,
        };
        fetch("https://back-crediseguro.com/getLocation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Ciudad) {
              const noneOption = document.createElement("option");
              noneOption.text = "--Ninguno--";
              noneOption.value = "";

              selectCity.appendChild(noneOption);

              data.Ciudad.map((city, i) => {
                const option = document.createElement("option");
                option.text = city.Nombre;
                option.value = city.Id;
                selectCity.appendChild(option);

                const optionsArray = Array.from(selectCity.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectCity.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectCity.appendChild(option);
                });
              });
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleGetFormData = () => {
    getRefreshDataState(!refreshData);
    setStepNumber(0);
    setProgress(1);
  };

  return (
    <div className="form-with-steps-container">
      <div className="header-title-container">
        <h1>Solicitud de {inputData.headerTitle} Persona Natural</h1>
      </div>
      <div className="steps-graph-container">
        {inputData.steps[stepNumber].subtitleStep}
        {hasSteps && (
          <div className="step-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${progressFraction * progress}%` }}
            ></div>
          </div>
        )}
      </div>
      {hasRestoreBtn && (
        <div className="reset-btn-container">
          <button
            title="Reiniciar Formulario"
            className="reset-btn"
            onClick={handleGetFormData}
          >
            Reiniciar Formulario
          </button>
        </div>
      )}
      {location.pathname === "/admin/crear-credito/verificar-datos" &&
        renovationUserData && (
          <div className="steps-graph-container subtitle">
            Titular del Crédito: {renovationUserData?.full_name}
          </div>
        )}
      <form
        className="fws-form-container"
        onChange={handleForm}
        onSubmit={handleSubmit}
      >
        {((location.pathname.includes("/admin/crear-credito/formulario") &&
          location.pathname === "/admin/crear-credito/formulario") ||
          (location.pathname.includes(
            "/admin/crear-credito/formulario-renovacion"
          ) &&
            location.pathname ===
              "/admin/crear-credito/formulario-renovacion")) && (
          <>
            <div className="current-step">
              <div className="current-step half-width">
                <label>
                  Asesor - Intermediario*:
                  <select
                    value={formData.broker}
                    name="broker"
                    title="select"
                    id="broker"
                    required
                    disabled={false}
                    autoComplete="off"
                  >
                    <option value="">--Ninguno--</option>
                  </select>
                  <span className="mandatory-text hide">Campo Obligatorio</span>
                </label>
              </div>
            </div>
            <h1
              className="steps-graph-container"
              style={{
                padding: 0,
              }}
            >
              Ingresa los Siguientes Datos del Titular del Crédito:
            </h1>
          </>
        )}
        <div
          className={`current-step ${
            inputData?.steps[0].inputs.length <= 1
              ? "full-width-input"
              : "half-width"
          }`}
        >
          {inputData.steps[stepNumber].inputs.map((input) => {
            if (input.isSelect) {
              if (input.viewPermissions?.includes(userProfile)) {
                return (
                  <label key={input.key}>
                    {input.title}
                    <select
                      value={formData[input.name]}
                      name={input.name}
                      title={input.typeVal}
                      id={input.name}
                      required
                      disabled={input.isBlocked}
                      autoComplete="off"
                    >
                      {!input.isBlocked && input.hasNoneOption && (
                        <option value="">--Ninguno--</option>
                      )}
                      {input.options.map((option, i) => {
                        return (
                          <option
                            key={i}
                            value={option.value ? option.value : option.title}
                            selected={option.isSelected}
                          >
                            {option.title}
                          </option>
                        );
                      })}
                    </select>
                    <span className="mandatory-text hide">
                      Campo Obligatorio
                    </span>
                  </label>
                );
              }
            }
            if (input.isRadio) {
              if (input.viewPermissions?.includes(userProfile)) {
                return (
                  <label key={input.key}>
                    {input.title}
                    <div className="radio-inputs-container">
                      Si
                      <input
                        type="radio"
                        name={input.name}
                        value={"true"}
                        title={input.typeVal}
                        id=""
                        checked={formData[input.name] === "true"}
                      />
                      No
                      <input
                        type="radio"
                        name={input.name}
                        value={"false"}
                        title={input.typeVal}
                        id=""
                        checked={formData[input.name] === "false"}
                      />
                    </div>
                    <span className="mandatory-text hide">
                      Campo Obligatorio
                    </span>
                  </label>
                );
              }
            }
            if (input.viewPermissions?.includes(userProfile)) {
              if (input.isDependent) {
                return (
                  <label key={input.key}>
                    {input.title}
                    <select
                      value={formData[input.name]}
                      name={input.name}
                      id={input.name}
                      title={input.typeVal}
                      onChange={(e) => handleDependent(e, input.childrenName)}
                      required
                      autoComplete="off"
                    >
                      <option value="">--Ninguno--</option>
                      {input.options.map((option, i) => {
                        return (
                          <option
                            key={i}
                            id={option.id ? option.id : ""}
                            value={option.title}
                          >
                            {option.title}
                          </option>
                        );
                      })}
                    </select>
                    <span className="mandatory-text hide">
                      Campo Obligatorio
                    </span>
                  </label>
                );
              }
            }
            if (input.viewPermissions?.includes(userProfile)) {
              return (
                <label key={input.key}>
                  {input.title}
                  <input
                    title={input.typeVal}
                    type={input.type}
                    name={input.name}
                    id={input.name}
                    value={formData[input.name]}
                    autoComplete="off"
                    required
                    disabled={input.isBlocked}
                  />
                  <span className="mandatory-text hide">Campo Obligatorio</span>
                </label>
              );
            }
          })}
        </div>
        <div className="fws-btns-container">
          {inputData.steps[stepNumber].hasPrev && (
            <button
              onClick={(e) => {
                e.preventDefault();
                setStepNumber(stepNumber - 1);
                setProgress(progress - 1);
              }}
              className="fws-btn"
              title="Anterior"
            >
              Anterior
            </button>
          )}
          {inputData.steps[stepNumber].hasNext && (
            <button onClick={handleNext} className="fws-btn" title="Siguiente">
              Siguiente
            </button>
          )}
          {inputData.steps[stepNumber].hasSend && (
            <button type="submit" className="fws-btn" title="Enviar">
              Enviar
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default FormWithStepsComponent;
